import React from 'react'

const ArrowRightMedium5 = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="31" height="26" viewBox="0 0 31 26">
          <path
              d="M21.769 11.6037C22.1689 12.0268 22.374 12.5909 22.374 13.1441C22.374 13.6974 22.1689 14.2615 21.769 14.6845L17.3702 19.3384L15.9245 17.8088L19.3082 14.2289L8.0293 14.2289L8.0293 12.0593L19.2979 12.0593L15.9245 8.47943L17.3702 6.9498L21.769 11.6037Z"
              fill="white"
          />
      </svg>
  );
}

export default ArrowRightMedium5
